import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Select, Store } from '@ngxs/store';
import { PhoneCountryCode } from 'app/models/dto/phone-country-code.model';
import { GetCountryData, SelectCountry } from 'app/store/country/country-data.actions';
import { CountryDataState } from 'app/store/country/country-data.state';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import flags from './flags';

@Component({
  selector: 'formly-country-select',
  template: `
  <div *ngIf="!field.hide" class="formly-sub-row">
    <mat-form-field class="formly-sub-column">
      <mat-label>Country</mat-label>
      <mat-select
        matInput
        panelWidth="196px"
        [formControl]="field.formControl"
        [formlyAttributes]="field"
        [(value)]="selectedCountry"
        data-cy="phone-country-code-select"
        (selectionChange)="updateSelectedCountry()">
        <mat-select-trigger *ngIf="selectedCountry">
          &nbsp; {{ flag(selectedCountry) }} &nbsp;
        </mat-select-trigger>
        <mat-option *ngFor="let phoneCountryCode of phoneCountryCodes" [value]="phoneCountryCode.id">
          <span style="margin-right:5px;">
            {{ flag(phoneCountryCode.id) }}&nbsp;
          </span>
          {{ phoneCountryCode.name }}
          +{{ phoneCountryCode.phoneCountryCode }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div style="margin-left: 5px"></div>
    </div>
  `,
  styleUrls: ['./formly-grid-styles.scss']
})
export class CountryCodeSelectComponent extends FieldType<FieldTypeConfig> implements OnInit {
  @Select(CountryDataState.phoneCountryCodes) phoneCountryCodes$: Observable<PhoneCountryCode[]>;
  phoneCountryCodes: PhoneCountryCode[];
  flags = flags;
  selectedCountry: number;
  mask: string;
  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store
  ) {
    super();
  }
  ngOnInit() {
    this.store.dispatch(new GetCountryData());
    this.selectedCountry = this.formControl.value;
    this.phoneCountryCodes$
      .pipe(first(val => val.length > 0))
      .subscribe(phoneCountryCodes => {
        this.phoneCountryCodes = phoneCountryCodes;
      });
  }

  updateSelectedCountry() {
    this.store.dispatch(new SelectCountry(this.selectedCountry));
  }

  idFromName(name: string) {
    if (!this.phoneCountryCodes) {
      return -1;
    }
    return this.phoneCountryCodes.find(c => c.name === name)?.id;
  }
  country(id: number) {
    if (!this.phoneCountryCodes) {
      return;
    }
    return this.phoneCountryCodes.find(c => c.id === id);
  }
  flag(id: number) {
    const country = this.country(id);
    if (!country) {
      return;
    }
    return flags[country?.countryCode].emoji;
  }
}
